export default "__VITE_ASSET__C7yh$QqP__"